export default "__VITE_ASSET__1d11d7cb__$_?component__"